var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Modal',{attrs:{"width":"1200","no-padding":true,"no-margin":true}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('pdf-certificate',{attrs:{"certificate":_vm.registryPDF},on:{"close":function($event){return _vm.$emit('close')}}})],1),_c('div',{attrs:{"slot":"footer"},slot:"footer"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }